import axios from 'axios';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getTheme = async () => {
  const token = localStorage.getItem('token');
  try {
    const response = await axios.get(`${API_BASE_URL}/theme`, {
      headers: {
        'Authorization': `${token}`,
      },
    });
    
    // Check if theme data exists in the response
    if (response.data.result?.status && response.data.result?.resource) {
      const resource = response.data.result.resource;
      
      // Set the CSS variable for the primary color
      if (resource.themeColors?.primary) {
        document.documentElement.style.setProperty(
          '--primary-color', 
          resource.themeColors.primary
        );
      }
      
      // Return the resource object directly for easier access in components
      return resource;
    } else {
      //console.error("No theme data found.");
      return null;
    }
  } catch (error) {
   //console.error("Error fetching theme data:", error.response?.data || error.message);
    // Just return null on error - will use the default color
    return null;
  }
};